var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 2.66659C5.05464 2.66659 2.66683 5.0544 2.66683 7.99992C2.66683 10.9454 5.05464 13.3333 8.00016 13.3333C10.9457 13.3333 13.3335 10.9454 13.3335 7.99992C13.3335 5.0544 10.9457 2.66659 8.00016 2.66659ZM1.3335 7.99992C1.3335 4.31802 4.31826 1.33325 8.00016 1.33325C11.682 1.33325 14.6668 4.31802 14.6668 7.99992C14.6668 11.6818 11.682 14.6666 8.00016 14.6666C4.31826 14.6666 1.3335 11.6818 1.3335 7.99992Z",
    fill: "#485D7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.52876 5.52851C5.78911 5.26816 6.21122 5.26816 6.47157 5.52851L8.00016 7.05711L9.52875 5.52851C9.7891 5.26816 10.2112 5.26816 10.4716 5.52851C10.7319 5.78886 10.7319 6.21097 10.4716 6.47132L8.94297 7.99992L10.4716 9.52851C10.7319 9.78886 10.7319 10.211 10.4716 10.4713C10.2112 10.7317 9.7891 10.7317 9.52875 10.4713L8.00016 8.94273L6.47157 10.4713C6.21122 10.7317 5.78911 10.7317 5.52876 10.4713C5.26841 10.211 5.26841 9.78886 5.52876 9.52851L7.05735 7.99992L5.52876 6.47132C5.26841 6.21097 5.26841 5.78886 5.52876 5.52851Z",
    fill: "#485D7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveLine);
export default __webpack_public_path__ + "static/media/removeLine.eadd81f7.svg";
export { ForwardRef as ReactComponent };